{
    "WebexAuth_UserIntro": "Oi **{}**,",
    "WebexAuth_UserIntro_2": "A CX Analytics está solicitando acesso ao seu locatário do Webex Calling.",
    "WebexAuth_AdminConsent": "Conceder consentimento administrativo",
    "WebexAuth_Authorise": "Autorizar",
    "WebexAuth_ConsentedMessage": "Consentimento do administrador concedido. Clique em Autorizar para continuar.",
    "WebexAuth_AuthorisedMessage": "Autorização concedida",
    "WebexAuth_Decline": "Declínio",
    "WebexAuth_Error_Unknown": "Ocorreu um erro não reconhecido. Tente novamente. Se o problema persistir, entre em contato com o administrador do sistema.",
    "NAME": "WebexAuthLanguage"
}